// ============================================
// CHARTS MAIN - Initialize all charts
// ============================================

import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register Chart.js components globally
Chart.register(...registerables, ChartDataLabels);

// Make Chart available globally
(window as any).Chart = Chart;

export function initCharts(): void {
    // Chart.js is now registered globally
    // Individual charts are initialized by their respective Alpine.js components
    // Example: ordersChartCard component handles initOrdersChart()
}
